import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Segmented status tabs — DESIGN_SYSTEM.md §6.
 * Pill container; active tab = white pill + shadow-sm. Presentational; the
 * parent owns the active value and applies it to the RA filter (Phase 3/4).
 */
export type SegmentedTab = { value: string; label: string; count?: number };

export function SegmentedTabs({
  tabs,
  value,
  onChange,
  className,
}: {
  tabs: SegmentedTab[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-1 rounded-pill bg-surface-2 p-1',
        className,
      )}
      role="tablist"
    >
      {tabs.map((tab) => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-pill px-3 py-1.5 text-[13px] font-semibold transition-colors duration-150',
              active
                ? 'bg-background text-ink shadow-latio-sm'
                : 'text-ink-2 hover:text-ink',
            )}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span
                className={cn(
                  'inline-flex h-4 min-w-4 items-center justify-center rounded-pill px-1 text-[11px] font-semibold',
                  active ? 'bg-indigo-tint text-indigo' : 'bg-background/70 text-ink-2',
                )}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
